export class TherapeuticClass {
  private therapeuticClassKey: string;
  private description: string;
  private code: string;

  setTherapeuticClassKey(value: string): void {
    this.therapeuticClassKey = value;
  }

  getTherapeuticClassKey(): string {
    return this.therapeuticClassKey;
  }

  setDescription(value: string): void {
    this.description = value;
  }

  getDescription(): string {
    return this.description;
  }

  setCode(value: string): void {
    this.code = value;
  }

  getCode(): string {
    return this.code;
  }
}
